import { useContext, useEffect, useState } from 'react';
import { SDKContext } from '../context/sdk';
import { useDesignIdQueryParam } from './useDesignIdQueryParam';

/**
 * Load in design asynchronously, defaulting to query param ?design_id=<design_id>.
 * You can override this by explicitly passing in a design ID.
 */
export function useLoadDesign(sdk: any, designIdOverride?: string) {
  const { setComponents, setError } = useContext(SDKContext);
  const [loadedDesign, setLoadedDesign] = useState<any>(null);
  const designIdQueryParam = useDesignIdQueryParam(); 
  const designId = designIdOverride || designIdQueryParam;

  useEffect(() => {
    console.log('Loading design: ' + designId);
    sdk?.design?.load(designId)
      .then((result: any) => {
        setLoadedDesign(result)
        return sdk.cad.getComponents()
          .then((components: any) => setComponents(components))
          .catch((err: any) => {
            console.warn(err);
            setError('An error occurred while loading the components.');
          })
      })
      .catch((err: any) => {
        console.warn(err);
        setError('An error occurred while loading the design. Make sure the URL has a design_id.');
      });
  }, [
    designId,
    sdk,
    setComponents,
    setError
  ]);
  
  return { loadedDesign };
  }